import apiClient from "../../../services/apiClient";
import { getHeaders } from "../../ApiHeaders/apiHeaders";

interface FetchMetricConfigParams {
  iso_code: string;
  category: string;
  group_by?: string;
  fuel_type?: string;
}

export const fetchMetricConfig = async ({
  iso_code,
  category,
  group_by = "AWARD_TYPE",
  fuel_type,
}: FetchMetricConfigParams) => {
  try {
    const headers = await getHeaders();

    const response = await apiClient.get("/ref-data/metric-config", {
      params: { iso_code, category, group_by, ...(fuel_type ? { fuel_type } : {}) },
      headers,
    });

    return response.data;
  } catch (error) {
    console.error("Metric Config API failed:", error);
    throw error;
  }
};
